var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddDietSmall = function SvgAddDietSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 86,
    viewBox: "0 0 125 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.08 78.4684H100.473C98.053 62.4756 84.7884 50.0636 68.413 48.9385C68.638 48.5349 68.7662 48.0694 68.7662 47.5734C68.7662 46.0364 67.5195 44.7762 65.9769 44.7762C64.4371 44.7762 63.1798 46.0336 63.1798 47.5734C63.1798 48.0695 63.308 48.5352 63.5342 48.939C47.1618 50.067 33.8931 62.4775 31.4809 78.4684H29.8658C29.2395 78.4684 28.6729 78.7231 28.2661 79.1378C27.8502 79.5458 27.5965 80.1206 27.5965 80.7377C27.5965 81.992 28.6157 83.0148 29.8658 83.0148H102.08C102.698 83.0148 103.274 82.7602 103.682 82.3429C104.093 81.9314 104.349 81.3668 104.349 80.7377C104.349 79.4894 103.328 78.4684 102.08 78.4684ZM49.2985 60.4152C45.7432 65.1219 42.4954 71.2863 41.5119 78.4684H37.3493C39.0869 67.354 46.163 58.2932 55.5153 53.6905C53.5837 55.3835 51.3831 57.6555 49.2985 60.4152Z",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.526 51.418C55.0821 54.0497 43.7909 64.5135 42.0338 79.0588H36.668C38.4723 65.7899 47.7306 55.2867 59.526 51.418Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109.689,
    y1: 0.507813,
    x2: 109.689,
    y2: 13.1148,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 103.199,
    y1: 6.86944,
    x2: 115.806,
    y2: 6.86944,
    stroke: "#FF5F5A",
    strokeWidth: 3.15175
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81.42,
    y1: 17.7109,
    x2: 81.42,
    y2: 24.2268,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 78.0664,
    y1: 21.0019,
    x2: 84.5823,
    y2: 21.0019,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10.3926,
    y1: 52.7188,
    x2: 10.3926,
    y2: 59.2346,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.03906,
    y1: 56.0097,
    x2: 13.5549,
    y2: 56.0097,
    stroke: "#FF5F5A",
    strokeWidth: 1.62897
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.913,
    y: 42.1345,
    width: 51.6099,
    height: 18.5165,
    rx: 2.95476,
    transform: "rotate(-25.1706 69.913 42.1345)",
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6367,
    y: 44.2227,
    width: 9.45524,
    height: 9.45524,
    rx: 1.57587,
    transform: "rotate(-25.1706 75.6367 44.2227)",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 1.18191
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.1992,
    y: 38.8047,
    width: 26.7898,
    height: 3.15175,
    rx: 0.787937,
    transform: "rotate(-25.1706 88.1992 38.8047)",
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5117,
    y: 43.7188,
    width: 17.3346,
    height: 3.15175,
    rx: 0.787937,
    transform: "rotate(-25.1706 90.5117 43.7188)",
    fill: "#E5E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3581,
    y: 58.6343,
    width: 40.7331,
    height: 14.6142,
    rx: 2.33205,
    transform: "rotate(18.8809 20.3581 58.6343)",
    fill: "white",
    stroke: "#1B382F",
    strokeWidth: 0.93282
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4609,
    y: 62.9609,
    width: 7.46256,
    height: 7.46256,
    rx: 1.24376,
    transform: "rotate(18.8809 22.4609 62.9609)",
    fill: "#FF5F5A",
    stroke: "#1B382F",
    strokeWidth: 0.93282
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5586,
    y: 66.7852,
    width: 21.1439,
    height: 2.48752,
    rx: 0.62188,
    transform: "rotate(18.8809 32.5586 66.7852)",
    fill: "#E5E5E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1719,
    y: 70.8398,
    width: 13.6814,
    height: 2.48752,
    rx: 0.62188,
    transform: "rotate(18.8809 31.1719 70.8398)",
    fill: "#E5E5E5"
  })));
};
export default SvgAddDietSmall;